import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestReturn from './RequestReturn';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, selectedItem, newRO, error, message,
  } = state.market;
  return {
    isLoading,
    selectedItem,
    newRO,
    error,
    message,
  };
}

const Styled = withStyles(styles)(RequestReturn);

export default connect(
  mapStateToProps,
)(Styled);
